import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './baseQuery';

const authAPI = createApi({
    reducerPath: "authAPI",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        hasAccess: builder.mutation({
            query: ({mobileNo}) => ({
                url: `/staff/check/phone`,
                params: { phone: mobileNo, checkMap: true },
                method: "GET"
            }),
            transformResponse: () => ({ hasAccess: true }),
            transformErrorResponse: () => ({ hasAccess: false })
        }),
        requestOtp: builder.mutation({
            query: ({mobileNo}) => ({
                url: `/auth/phone/send-otp`,
                body: {phoneNo: mobileNo},
                method: "POST"
            }),
            transformResponse: (response) => response
        }),
        verifyOtp: builder.mutation({
            query: ({mobileNo, otp}) => ({
                url: `/auth/phone/verify-otp`,
                method: "POST",
                body: {
                    phoneNo: mobileNo,
                    otp: String(otp)
                }
            }),
            transformResponse: (response) => response
        }),
    }),
});

export const { 
    useHasAccessMutation,
    useRequestOtpMutation,
    useVerifyOtpMutation
} = authAPI;

export default authAPI;
